import { createContext, type ReactNode } from "react";


export type SnackbarNotification = {
  message: string;
  buttonLabel?: string;
  onClick?: () => void | Promise<void>;
  icon?: ReactNode;
};

export interface SnackbarContextType {
  showSuccess: (message: string, onUndo?: () => void) => void;
  showError: (message: string) => void;
  showInfo: (message: string | SnackbarNotification) => void;
}

export const SnackbarContext = createContext<SnackbarContextType | undefined>(
  undefined,
);

export default SnackbarContext;
